import React, { useCallback } from "react";
import List from "devextreme-react/list";
import { Link } from "react-router-dom";
import "./navigationList.css";

const navigation = [
  { id: 1, text: "Dashboards", icon: "mediumiconslayout", path: "" },
  { id: 2, text: "Widgets", icon: "edit", path: "widgets" },
  { id: 3, text: "Roles", icon: "accountbox", path: "roles" }
];

function NavigationList({ setIsOpened }) {
  const closeDrawer = () => {
    setIsOpened(false);
  };

  const renderItem = useCallback((data) => {
    return (
      <div className="navigation-item">
        <Link to={"/" + data.path} className="navigation-link">
            <div className="dx-list-item-icon-container">
              <i className={`dx-icon dx-list-item-icon dx-icon-${data.icon}`} />
            </div>
            <span>{data.text}</span>
        </Link>
      </div>
    );
  }, []);

  return (
    <div>
      <List
        items={navigation}
        height={"100%"}
        selectionMode="single"
        onSelectionChanged={closeDrawer}
        itemRender={renderItem}
        className="navigation-list"
      />
    </div>
  );
}

export default NavigationList;
